import {Component, Input, inject} from '@angular/core';
import {MenuItem} from '../classes/menu-item';
import {Router} from '@angular/router';
import {MatDrawer} from '@angular/material/sidenav';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItemIcon } from '@angular/material/list';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'nbd-nav-menu-item',
    templateUrl: './nav-menu-item.component.html',
    styleUrls: ['./nav-menu-item.component.scss'],
    imports: [MatButton, MatIcon, MatListItemIcon, MatExpansionPanel, MatExpansionPanelHeader, TranslatePipe]
})
export class NavMenuItemComponent {
  private router = inject(Router);


  @Input() m?: MenuItem;
  @Input() collapsed: boolean = false;
  @Input() isHandset: boolean = false;
  @Input() drawer?: MatDrawer;
  @Input() bgClass?: string;

  handleClick(event: MouseEvent) {
    if (this.m) {

      if (this.m.onClick) {
        this.m.onClick();
      }

      if (!this.m.isActive || !this.m.children?.length) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (this.isHandset) {
        this.drawer?.close();
      }

      // Pure action items (no url — e.g. the sidebar Upgrade item, which opens a
      // dialog via onClick) must NOT navigate. Only route when a url is present.
      if (this.m.url) {
        this.router.navigate([this.m.url]);
      }

    }
  }

}
